export default __webpack_public_path__ + "static/media/Transaction.780a8fdb.svg";